export default __webpack_public_path__ + "86cb1ab018f1680d8e0fa0ca6a53d64c.ttf";